module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/babel-runtime/core-js/promise.js
// module id = 457
// module chunks = 0